exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-item-insurance-description {\n  margin-top: 5px;\n  font-size: 14px;\n}\n.order-item-insurance-description p {\n    margin: 0;\n}\n", ""]);

// exports
